import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

/**
 * Parses comma-separated API IDs.
 *
 * Returns a list of API IDs if every token matches the given model type.
 *
 * @package
 */
export function parseApiIdsClipboardContent(
  text: string,
  modelType: ModelTypeConstants
): Array<string> | null {
  const apiIds = text
    .split(',')
    .map((apiId) => apiId.trim())
    .filter((apiId) => apiId.length > 0);
  if (apiIds.length === 0 || !apiIds.every((apiId) => APIUtil.apiIdToMaybeType(apiId) === modelType)) {
    return null;
  }
  return apiIds;
}
